import {ENTERPRISE} from 'Constants/ActionTypes';

const {
  GET_COMPANY_INFO_LIST,
  SET_COMPANY_INFO_CONFIG_MODAL_DATA,
  ADD_COMPANY_INFO,
  CONFIG_COMPANY_INFO,
} = ENTERPRISE;
// 通用前缀
const url = '/robot/app/companyInfo';

const actions = {
  // 系统设置-话术列表-列表
  getTableList() {
    return {
      type: GET_COMPANY_INFO_LIST,
      payload: {
        request: {
          method: 'get',
          url: `${url}`,
        },
      },
    };
  },
  // 系统设置-话术列表-获取配置弹框的数据
  setConfigModalData(data) {
    return {
      type: SET_COMPANY_INFO_CONFIG_MODAL_DATA,
      data,
    };
  },
  // 系统设置-话术列表-添加
  addCompanyInfo(data) {
    return {
      type: ADD_COMPANY_INFO,
      payload: {
        request: {
          method: 'post',
          url: `${url}`,
          data,
        },
      },
    };
  },
  // 系统设置-话术列表-配置
  configCompanyInfo(data) {
    return {
      type: CONFIG_COMPANY_INFO,
      payload: {
        request: {
          method: 'put',
          url: `${url}`,
          data,
        },
      },
    };
  },
};

export default actions;
